import { formatSystemApiRelativeUrl } from "@contember/client";
import { useGraphQlClient } from "../useGraphQlClient.js";
const useSystemGraphQlClient = (projectSlug) => useGraphQlClient(formatSystemApiRelativeUrl(projectSlug));
export {
  useSystemGraphQlClient
};
//# sourceMappingURL=useSystemGraphQlClient.js.map
